import { useTranslation, NextgenImage, LoaderType } from '@nextgen-web-framework/all';
import { AssetPath } from '../../../utils/Constants';
import styles from './EmptyAddressBook.module.scss';

export const EmptyAddressBook = () => {
  const t = useTranslation();
  return (
    <>
      <div className={styles['empty-address-book-container']}>
        <div className={styles['empty-address-book-img']}>
          <NextgenImage
            src={`${AssetPath.NO_RESULT_IMAGE}`}
            isRelativeURL={true}
            loaderType={LoaderType.WEBFONTS}
            alt="No address"
            layout="fixed"
          />
        </div>
      </div>
      <div className={styles['empty-address-book-heading']}>
        {t('profile.emptyAddressBook.heading')}
        <div className={styles['empty-address-book-detail']}>{t('profile.emptyAddressBook.detail')}</div>
      </div>
    </>
  );
};
export default EmptyAddressBook;
